module.exports = __webpack_public_path__ + "img/blockchain_3.facf68a5.png";